import React from "react";
import Featured from "./Featured";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import Brightness from "../scripts/Brightness";

import SiteIcons from "../assets/SiteIcons";

const Home = props => {
  const NavHide = () => {
    props.navChange("hideNav");
  };

  const NavChange = e => {
    e.preventDefault();
    props.navTypeChange("categories");
    props.navChange();
  };

  let mobileClass;

  if (props.mobile === true) {
    mobileClass = " mobile";
  } else {
    mobileClass = "";
  }

  const OtherLinks = styled.div`
    a {
      color: ${props.themeStyles.linkColor};

      .icon {
        #accent {
          stroke: ${props.themeStyles.svgColor};
        }

        #lines {
          stroke: ${props.themeStyles.svgColor};
        }

        #fill {
          fill: none;
        }
      }

      &:hover {
        color: ${props.themeStyles.svgHover};

        .icon {
          #accent {
            stroke: ${props.themeStyles.background};
            stroke-width: 12px;
          }

          #lines {
            stroke: ${props.themeStyles.svgHover};
          }

          #fill {
            fill: ${props.themeStyles.svgHover};
          }

          &.alternate {
            #lines {
              stroke: none;
            }
          }
        }
      }
    }
  `;

  return (
    <div className="homeContainer">
      {props.mobile === false && (
        <Featured
          jsonData={props.jsonData}
          localURL={props.localURL}
          themeStyles={props.themeStyles}
        />
      )}
      <section className={"otherLinksContainer" + mobileClass}>
        <OtherLinks className="otherLinks">
          <NavLink onClick={NavHide} to="/courses">
            <SiteIcons icon="courses" />
            <span>View all courses</span>
          </NavLink>
          <a onClick={NavChange}>
            <SiteIcons icon="categories" />
            <span>Browse by category</span>
          </a>
          <NavLink onClick={NavHide} to="/requirements">
            <SiteIcons icon="system" />
            <span>System requirements</span>
          </NavLink>
        </OtherLinks>
      </section>
    </div>
  );
};

export default Home;
